import { Directive, Input, ElementRef, AfterViewInit } from '@angular/core';

@Directive({ selector: '[masonry]' })
export class MasonryDirective implements AfterViewInit {

  $el : any;

  constructor(el: ElementRef) {
    this.$el = $(el.nativeElement);
  }

  ngAfterViewInit() {
    setTimeout(() => {
        (<any>this.$el).masonry({
          // set itemSelector so .grid-sizer is not used in layout
          percentPosition: true,
          resize: true
        });
      }, 100)
  }
}
